import {ref, computed, watch, toRaw} from 'vue'
import {useRouter} from 'vue-router'

import LxUtils from '../lib/lxutils.js'

// window.addEventListener('popstate', (event) => {
//   console.log(event?.state?.current)
//   // add tab if not exist
//
// })

const useTabs = ref(true)
const cachedViews = ref([])
const cachedTabs = ref([
  {
    icon: '#location',
    iconType: 'svg',
    id: '7068ed30-de44-41d4-91a9-b2afa2dbe63d',
    notClosable: true,
    path: '/admin/dashboard',
    title: 'Dashboard'
  }
])
const activeTabId = ref("b95a2848-19ef-411e-8fbe-6ad0f704ebe5")

const keepAliveInstance = ref(null)
const routerInstance = ref(null)

let idleInterval = null
let updateUserAccount = null

let returnValue = 'settings'

/**
 * Updates der tab settings im user obejt
 */
function updateUser() {
  if (updateUserAccount) {

    // wenn man es nicht dauerhaft am nutzer speichern möchte oder während der aktuellen session
    // settings_local  || settings
    // settings ist default

    // let tmpCaTa = structuredClone(toRaw(cachedTabs.value)) //scheint nicht immer zu gehen weil ne function drin ist in manchen tabs
    let tmpCaTa = JSON.parse(JSON.stringify(cachedTabs.value))

    tmpCaTa.forEach((item) => {
      delete item.unsaved  //ungesichert eigenschaft entfernen, damit nach refresh nicht fälschliche ungesichert da steht
    })

    let temp = {}
    temp[returnValue] = {
      tabs: {
        cached: tmpCaTa, //cachedTabs.value,
        active: activeTabId.value,
        useTabs: useTabs.value
      }
    }

    updateUserAccount(temp)
  }
}

/**
 * Füge alle tabs aus den usersettings hinzu die der nutzer gepeichert hatte
 *
 * @param value
 * @param userTabs
 * @param saveLocal
 * @param saveUseTabs //wenn true oder false will man direkt einstellen ob man tabs oder nicht tabs nutzen möchte, ansonsten wenn undefined dann werden tabs verwendet bzw. das was man eingestellt hat
 */
function addTabsFromUserSetting(value, userTabs, saveLocal, saveUseTabs) {
  updateUserAccount = value
  if (userTabs) {
    if (typeof saveUseTabs === 'boolean') {
      useTabs.value = saveUseTabs
    } else if (typeof userTabs.useTabs === 'boolean') {
      useTabs.value = userTabs.useTabs
    }
    cachedTabs.value = userTabs.cached
    activeTabId.value = userTabs.active //"b95a2848-19ef-411e-8fbe-6ad0f704ebe5"
  }
  if (saveLocal) {
    returnValue = 'settings_local'
  }

  navigateTo(activeTabId.value)
}


/**
 * Öffne ein bestimmtes tab anhand seiner id
 *
 * @param id
 */
function navigateTo(id) {
  if (activeTabId.value !== id) {
    cachedTabs.value.forEach((item) => {
      if (id === item.id) {
        routerInstance.value.push({path: item.path})
      }
    })
    activeTabId.value = id

    idleInterval = setInterval(() => scrollTabIntoViewByTab(id), 50)

    updateUser()
  }
}


/**
 * Hinzufügen eines neuen tabs zum store oder öffnen eines bereits vorhandenen
 *
 * @param path
 * @param value
 */
async function addTabToStore(path, value) {
  let title = value.title || '####'
  let subtitle = value.subtitle
  let icon = value.icon
  let iconType = value.iconType
  let notUnique = value.notUnique
  let notClosable = value.notClosable
  let payload = value.payload
  let setNextToCurrent = value.setNextToCurrent
  let guid = LxUtils.generateUuidV4()
  let tmpTab = null
  let found = null

  if (cachedTabs.value && cachedTabs.value.length > 0) {
    found = cachedTabs.value?.filter((item) => {
      if (item.path === path) {
        tmpTab = item
      }
      return item.path === path
    })
  }

  // add or show tab
  if (notUnique || (!notUnique && !found) || (!notUnique && found.length <= 0)) {
    // add tab to list

    let tmpActiveID = structuredClone(toRaw(activeTabId.value))
    let tabObj = {
      path: path,
      title: title,
      subtitle: subtitle,
      id: guid,
      icon: icon,
      iconType: iconType,
      notClosable: notClosable,
      payload: payload,
    }
    let lastTab = null

    cachedTabs.value.forEach((item, index) => {
      if (item.id === JSON.parse(JSON.stringify(activeTabId.value))) {
        lastTab = index
      }
    })

    if (typeof lastTab === 'number' && setNextToCurrent) {
      cachedTabs.value.splice(lastTab + 1, 0, tabObj)
    } else {
      cachedTabs.value.push(tabObj)
    }

    activeTabId.value = guid

    routerInstance.value.push({path: path}).then((a, b, c) => {
      //wenn nicht undefined ist dann ist fehler beim navigieren passiert, in diesem fall muss neues tab wieder entfertnt werden
      if (a) {
        if (typeof lastTab === 'number' && setNextToCurrent) {
          cachedTabs.value.splice(lastTab + 1, 1)
        } else {
          cachedTabs.value.pop()
        }

        activeTabId.value = tmpActiveID
      }

    }).catch((err) => {
      console.log('---CATCH---', err)
    })

  } else if (!notUnique && found) {
    if (tmpTab) {
      tmpTab.payload = value.payload
    }

    routerInstance.value.push({path: found[0].path})
    activeTabId.value = found[0].id
  }

  idleInterval = setInterval(() => scrollTabIntoViewByTab(activeTabId.value), 50)

  updateUser()
}

/**
 * Wählt man in der liste ein nicht sichtbares tab aus, wird gescrollt bis dieses sichtbar ist
 *
 * @param id
 */
function scrollTabIntoViewByTab(id) {
  let el = document.getElementById('tab' + id)
  if (el) {
    clearInterval(idleInterval)
    el.scrollIntoView()
  }
}

//
// function getActiveTabId() {
//   return activeTabId.value
// }

/**
 * Ändere die tab eigenschaften für das übergebene tab mit den übergebenen werten
 *
 * @param tabId
 * @param values
 */
function updateTabInStore(tabId, values) {
  cachedTabs.value.forEach(item => {
    if (item.id === tabId) {
      if (values.title) {
        item.title = values.title
      }
      if (values.subtitle) {
        item.subtitle = values.subtitle
      }
      if (values.path) {
        item.path = values.path
      }
      if (values.icon) {
        item.icon = values.icon
      }
      if (values.payload) {
        item.payload = values.payload
      }
    }
  })

  updateUser()
}

/**
 * Schließe alle tabs außer das ausgewählte, nicht schließbar und ungesicherte
 *
 * @param id
 */
function closeOtherTabs(id) {
  if (cachedTabs.value.length > 0) {
    let tmp = cachedTabs.value.filter(item => item.id === id || item.notClosable || item.unsaved)
    cachedTabs.value = tmp || []

    let pathItem = cachedTabs.value.filter(item => item.id === id)
    if (pathItem.length > 0) {
      activeTabId.value = pathItem[0].id
      routerInstance.value.push({path: pathItem[0].path})
    }
    updateUser()
  }
}

/**
 * Schließe alle tabs, außer nicht schließbar und ungesicherte
 */
function closeAllTabs() {
  if (cachedTabs.value.length > 0) {
    let tmp = cachedTabs.value.filter(item => item.notClosable || item.unsaved)
    cachedTabs.value = tmp || []

    if (tmp.length > 0) {
      activeTabId.value = tmp[0].id
      routerInstance.value.push({path: tmp[0].path})
    }
    updateUser()
  }
}

/**
 * Schließe tab anhand seiner id
 *
 * @param id
 */
function closeTab(id) {
  let index = null
  for (let i = 0; i < cachedTabs.value.length; i++) {
    if (cachedTabs.value[i].id === id) {
      index = i
      break
    }
  }

  if (!cachedTabs.value[index]?.notClosable) {
    if (index >= 0 && activeTabId.value === id) {
      cachedTabs.value.splice(index, 1)
      setTimeout(() => {
        let tempIndex = index - 1 > 0 ? index - 1 : 0
        if (cachedTabs.value.length > 0) {
          activeTabId.value = cachedTabs.value[tempIndex].id
          routerInstance.value.push({path: cachedTabs.value[tempIndex].path})
        } else {
          routerInstance.value.push({path: '/empty'})
        }
      }, 50)
    } else if (index >= 0 && activeTabId.value !== id) {
      cachedTabs.value.splice(index, 1)
    }
    updateUser()
  }
}


/**
 * watched die boolean variable useTabs, diese schaltet das Layout zwischen Tabs und nicht Tabs hin und her
 * das bedeutet auch keep-alive und nicht keep-alive
 */
watch(useTabs, (newVal) => {
  if (typeof newVal === 'boolean') {
    if (cachedTabs.value.length > 0) {
      let tmp = cachedTabs.value.filter(item => item.id === activeTabId.value || item.notClosable)
      cachedTabs.value = tmp || []

      updateUser()
    }
  }
})


/**
 * Computed gibt entweder das aktuelle tab zurück oder eine liste aller gecachten, welche an keep-alive include="included" übergeben wird um komponenten keep alive zu halten oder nicht
 *
 * @type {ComputedRef<null|*[]>}
 */
const included = computed(() => {
  if (!useTabs.value) {
    return cachedTabs.value.filter((item) => {
      return item.id === activeTabId.value
    })
  } else {
    return cachedTabs.value.map((item) => {
      return item.path
    })
  }
})


export const useNavigation = () => {

  const localTabId = structuredClone(toRaw(activeTabId.value))

  const tabIsUnsaved = ref(false)

  if (!routerInstance.value) {
    routerInstance.value = useRouter()
    //
    // let i = 0
    // routerInstance.value.beforeEach((to, from, next) => {
    //
    //   if (!from.name) {
    //
    //   }
    //   i++;
    //   next()
    // })
  }

  /**
   * Setzt die eigenschaft des tabs auf ungesichert oder nicht
   * da das tab anhand seiner localTabId erkannt wird muss man keine id übergeben
   *
   * @param values
   */
  function setTabUnsaved(values) {
    cachedTabs.value.forEach(item => {
      if (item.id === localTabId) {
        item.unsaved = values
      }
    })
  }

  /**
   * Setzt die keepaliveinstance in der alles gespeichert wird
   *
   * @param instance
   */
  function setKeepAliveInstance(instance) {
    keepAliveInstance.value = instance
  }

  // computed

  const activeTab = computed(() => {
    return cachedTabs.value.filter((item) => {
      return item.id === activeTabId.value
    })
  })

  return {
    useTabs,
    cachedViews,
    cachedTabs,
    included,
    localTabId,
    activeTabId,
    // getActiveTabId,
    activeTab,
    tabIsUnsaved,
    setTabUnsaved,
    updateTabInStore,
    setKeepAliveInstance,
    addTabToStore,
    addTabsFromUserSetting,
    closeTab,
    closeAllTabs,
    closeOtherTabs,
    navigateTo
  }
}
